/**
 * @file 数据加密解密
 * @author svon.me@gmail.com
 **/


import CryptoJS from 'crypto-js';

export class Config {
  iv: string = "";
  mode: string = "ECB";
  padding: string = "Pkcs7";
}

const correctSecretKey = function (secret: string = ""): string {
  const basic: number = 8;
  const remainder: number = secret.length % basic;
  if (remainder > 0 || secret.length < basic) {
    // 如果长度不是 8 的倍数，则追加字符
    const tmp: string = new Array(basic - remainder).fill("X").join("");
    secret = `${secret}${tmp}`;
  }
  return CryptoJS.enc.Utf8.parse(correctSecretKey(secret));
}

const getOption = function (config: Config = new Config()): object {
  return {
    iv: CryptoJS.enc.Utf8.parse(config.iv || ""),
    mode: CryptoJS.mode[config.mode || "ECB"],
    padding: CryptoJS.pad[config.padding || "Pkcs7"]
  }
}
/** 字符串加密 */
export const encrypt = function (value: string, SecretKey?: string, config?: Config): string {
  const option = getOption(config);
  const key = correctSecretKey(SecretKey);
  const result = CryptoJS.AES.encrypt(value, key, option);
  return result.toString()
}

/** 字符串解密 */
export const decrypt = function (value: string, SecretKey: string, config: Config = new Config()): string {
  const option = getOption(config);
  const key = correctSecretKey(SecretKey);
  const result = CryptoJS.AES.decrypt(value, key, option);
  return CryptoJS.enc.Utf8.stringify(result);
}
